import {Injectable} from '@angular/core';
import {ApiService} from "../api/api.service";
import {
  IGetUserList,
  IUserCreate,
  IUserUpdate
} from '../../../pages/management/user-management/interface/user-create.interface';
import {Observable} from 'rxjs';
import {IPagination} from "../api/interface/pagination.interface";

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(private readonly apiService: ApiService) {
  }

  getList() {
    return this.apiService.get<IGetUserList[]>('user')
  }

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(`user/user-filter-list`, {event: event, filter: filter})
  }

  createUser(user: IUserCreate): Observable<IGetUserList> {
    return this.apiService.post<IGetUserList>(`user/create`, user)
  }

  updateUser(user: IUserUpdate): Observable<IGetUserList> {
    return this.apiService.patch<IGetUserList>(`user/update`, user)
  }

  deleteUser(userId: number): Observable<{ success: boolean }> {
    return this.apiService.delete<{ success: boolean }>(`user/delete/${userId}`)
  }

  resetPassword(userId: number, sendType: string): Observable<IGetUserList> {
    return this.apiService.patch<IGetUserList>(`user/reset-password-user`, {userId: userId, sendType: sendType})
  }


  changePassword(data: { id: number, oldPassword: string, newPassword: string, newPasswordConfirm: string }) {
    return this.apiService.patch<IGetUserList>(`user/change-password`, data)
  }

  getUsersForStaff() {
    return this.apiService.get<any>('user/for-staff')
  }

  getUsersForRole() {
    return this.apiService.get<any>('user/for-role')
  }

  getUserWithRoleDetails(userId: number) {
    return this.apiService.get<any>(`user/${userId}/role-details`)
  }

  getUserWithTeams(userId: number) {
    return this.apiService.get<any>(`user/${userId}/user-teams`)
  }
}
